import { render } from "./popup.vue?vue&type=template&id=4c693c9e"
import script from "./popup.vue?vue&type=script&lang=js"
export * from "./popup.vue?vue&type=script&lang=js"

import "./popup.vue?vue&type=style&index=0&id=4c693c9e&lang=css"
script.render = render

export default script